import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ServicesGrid } from "@/components/ServicesGrid";
import { FadeUp } from "@/components/Motion";
import { buildMeta, buildLinks, breadcrumbSchema } from "@/lib/seo";
import { whatsappLink } from "@/lib/site";

export const Route = createFileRoute("/servicos/")({
  head: () => ({
    meta: buildMeta({
      title: "Serviços de Podologia em Belém do Pará | Podomasso",
      description:
        "Conheça todos os tratamentos da Podomasso: unha encravada, calos, micose, pé diabético, órtese, verrugas plantares e mais — em Belém do Pará.",
      path: "/servicos",
    }),
    links: buildLinks("/servicos"),
    scripts: [
      breadcrumbSchema([
        { name: "Início", path: "/" },
        { name: "Serviços", path: "/servicos" },
      ]),
    ],
  }),
  component: ServicosPage,
});

function ServicosPage() {
  return (
    <>
      <section className="bg-gradient-soft py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeUp>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-primary">
              Nossos Tratamentos
            </p>
            <h1 className="max-w-3xl font-display text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">
              Tratamentos Especializados de Podologia em{" "}
              <span className="text-gradient-hero">Belém do Pará</span>
            </h1>
            <p className="mt-8 max-w-2xl text-lg leading-loose text-muted-foreground lg:text-xl">
              Da unha encravada ao pé diabético — soluções modernas, indolores e seguras com a
              podóloga Rosa Chagas. Nosso compromisso é levar alívio e bem-estar para cada passo seu.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-background py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <ServicesGrid />
          <div className="mt-14 rounded-3xl bg-gradient-hero p-10 text-center text-primary-foreground shadow-elegant">
            <h2 className="font-display text-2xl font-bold sm:text-3xl">
              Não sabe qual tratamento é o ideal para você?
            </h2>
            <p className="mx-auto mt-3 max-w-xl opacity-90">
              Agende uma avaliação e a podóloga Rosa Chagas indicará o protocolo certo.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Button asChild variant="whatsapp" size="lg">
                <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
                  Agendar pelo WhatsApp <ArrowRight className="h-4 w-4" />
                </a>
              </Button>
              <Button asChild variant="soft" size="lg">
                <Link to="/agendamento">Preencher formulário</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
